// Square Images Lotería deck — 54 figures in standard Lotería order (1-54).
// User-uploaded artwork with bold square framing. Served as static frontend
// assets from /loteria-square/*.webp (~1.2MB total deck).
const NAMES = [
  "El Gallo", "El Diablito", "La Dama", "El Catrín", "El Paraguas",
  "La Sirena", "La Escalera", "La Botella", "El Barril", "El Árbol",
  "El Melón", "El Valiente", "El Gorrito", "La Muerte", "La Pera",
  "La Bandera", "El Bandolón", "El Violoncello", "La Garza", "El Pájaro",
  "La Mano", "La Bota", "La Luna", "El Cotorro", "El Borracho",
  "El Negrito", "El Corazón", "La Sandía", "El Tambor", "El Camarón",
  "Las Jaras", "El Músico", "La Araña", "El Soldado", "La Estrella",
  "El Cazo", "El Mundo", "El Apache", "El Nopal", "El Alacrán",
  "La Rosa", "La Calavera", "La Campana", "El Cantarito", "El Venado",
  "El Sol", "La Corona", "La Chalupa", "El Pino", "El Pescado",
  "La Palma", "La Maceta", "El Arpa", "La Rana",
];

export const SQUARE_LOTERIA_FIGURES = NAMES.map((name, i) => {
  const n = String(i + 1).padStart(2, "0");
  return { id: `sq-${n}`, name, src: `/loteria-square/sq-${n}.webp` };
});
